import React, {useState} from 'react';
import {Paper, Stack, Typography} from '@mui/material';
import CoverageSourcePane from './CoverageSourcePane';
import {COVERAGE_SOURCE} from '../coverageSourceTheme';

/**
 * ICR or EEI card: question text with side-by-side Data | Analytics panes.
 * `lens` of data/analytics shows one pane; both shows them side by side.
 */
export default function CoverageItemCard({
    title,
    titlePrefix = null,
    onPrefixClick,
    lens = 'both',
    dataCoveragePct = null,
    dataCaption,
    dataEvidence = null,
    analyticCoveragePct = null,
    analyticCaption,
    analyticEvidence = null,
}) {
    const [expandedSource, setExpandedSource] = useState(null);
    const showData = lens === 'both' || lens === 'data';
    const showAnalytics = lens === 'both' || lens === 'analytics';

    const toggle = (sourceId) => {
        setExpandedSource((prev) => (prev === sourceId ? null : sourceId));
    };

    return (
        <Paper variant="outlined" sx={{p: 2, borderRadius: 2}}>
            <Stack spacing={1.5}>
                <Typography variant="body1" sx={{lineHeight: 1.75}}>
                    {titlePrefix ? (
                        <Typography
                            component="span"
                            fontFamily="monospace"
                            color="primary"
                            sx={{
                                mr: 1,
                                cursor: onPrefixClick ? 'pointer' : 'inherit',
                                textDecoration: onPrefixClick ? 'underline' : 'none',
                            }}
                            onClick={onPrefixClick}
                        >
                            {titlePrefix}
                        </Typography>
                    ) : null}
                    {title}
                </Typography>
                <Stack direction={{xs: 'column', sm: 'row'}} spacing={1.25} alignItems="stretch">
                    {showData ? (
                        <CoverageSourcePane
                            source={COVERAGE_SOURCE.DATA}
                            coveragePct={dataCoveragePct}
                            caption={dataCaption}
                            expanded={expandedSource === COVERAGE_SOURCE.DATA.id}
                            onToggle={() => toggle(COVERAGE_SOURCE.DATA.id)}
                            testId="coverage-pane-data"
                        >
                            {dataEvidence}
                        </CoverageSourcePane>
                    ) : null}
                    {showAnalytics ? (
                        <CoverageSourcePane
                            source={COVERAGE_SOURCE.ANALYTICS}
                            coveragePct={analyticCoveragePct}
                            caption={analyticCaption}
                            expanded={expandedSource === COVERAGE_SOURCE.ANALYTICS.id}
                            onToggle={() => toggle(COVERAGE_SOURCE.ANALYTICS.id)}
                            testId="coverage-pane-analytics"
                        >
                            {analyticEvidence}
                        </CoverageSourcePane>
                    ) : null}
                </Stack>
            </Stack>
        </Paper>
    );
}
